import { ClipboardList, Wrench, CheckCircle2, Euro } from "lucide-react";
import { useOrders } from "@/lib/OrdersContext";
import { eur } from "@/lib/workshop";

export const Metrics = () => {
  const { filtered } = useOrders();
  const items = [
    { id: "active", label: "Órdenes Activas", value: filtered.length, icon: ClipboardList },
    { id: "repair", label: "En Reparación", value: filtered.filter((o) => o.estado === "en_reparacion").length, icon: Wrench },
    { id: "ready", label: "Listas para Entregar", value: filtered.filter((o) => o.estado === "listo_entregar").length, icon: CheckCircle2 },
    { id: "billing", label: "Facturación Estimada", value: eur(filtered.reduce((s, o) => s + o.importe, 0)), icon: Euro, gold: true },
  ];
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
      {items.map(({ id, label, value, icon: Icon, gold }, i) => (
        <div
          key={id} data-testid={`metric-${id}`} style={{ animationDelay: `${i * 60}ms` }}
          className={`rise relative overflow-hidden rounded-xl border p-4 md:p-5 ${gold ? "border-[var(--gold)]/30 bg-gradient-to-br from-[#1a140a] to-[#0f0f12]" : "border-white/5 bg-[#111114]"}`}
        >
          <div className="flex items-center justify-between">
            <p className="text-xs font-medium uppercase tracking-wider text-zinc-500">{label}</p>
            <Icon className={`h-4 w-4 ${gold ? "text-[var(--gold)]" : "text-zinc-600"}`} />
          </div>
          <p data-testid={`metric-${id}-value`} className={`font-display mt-3 text-2xl font-bold md:text-3xl ${gold ? "text-[var(--gold)]" : ""}`}>{value}</p>
        </div>
      ))}
    </div>
  );
};
